"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Image = require("@ccw-pwa-ui/Image");
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _images = require("../common_features/assets/images");
var _Header = require("@ccw-pwa-ui/Header");
var _helper = require("../common_features/utility/helper");
var _CustomOtpInput = require("@ccw-pwa-ui/CustomOtpInput");
require("../styles/ForgotPasswordOtpComponentStyle.css");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _reactBootstrap = require("react-bootstrap");
var _bs = require("react-icons/bs");
var _reactCountdown = _interopRequireWildcard(require("react-countdown"));
var _Button = require("@ccw-pwa-ui/Button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ForgotPasswordOtpComponent = props => {
  const type = (0, _helper.getPlatformType)();
  const renderer = _ref => {
    let {
      minutes,
      seconds
    } = _ref;
    return /*#__PURE__*/_react.default.createElement("span", null, (0, _reactCountdown.zeroPad)(minutes), ":", (0, _reactCountdown.zeroPad)(seconds));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "otp-main-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "otp-header-container"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: props.headerText,
    handleBack: props.handleBack,
    leftArrowImage: _index.default.leftArrow.default
  })), props.displayModal && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.displayModal,
    modalHeaderText: props.modalHeaderText,
    modalHeaderTextStyle: props.modalHeaderTextStyle,
    modalDetailText: props.modalDetailTextFail,
    modalHeaderIcon: props.modalHeaderIcon,
    displayCrossIcon: props.displayCrossIcon,
    variant: props.variant,
    positiveActionButtonTitle: props.positiveActionButtonTitle,
    positiveAction: props.positiveAction,
    negativeButtonActionTitle: props.negativeButtonActionTitle,
    crossIconAction: props.crossIconAction,
    negativeAvtion: props.negativeAvtion
  })), props.isSuccessModal ? /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.displayPasswordChangeModal,
    modalDetailText: props.modalDetailText,
    modalHeaderIcon: true,
    variant: "password-change-modal",
    positiveActionButtonTitle: props.continueButtonText,
    positiveAction: props.setDisplayPasswordChangeModal
  }) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "white_logo"
  }, /*#__PURE__*/_react.default.createElement(_Header.Header, {
    style: {
      position: 'fixed',
      zIndex: "99",
      height: "80px"
    },
    type: type ? "Desktop" : '',
    imageUrl: type ? _images.Pentair_Logo_white.default : _images.Pentair_Logo.default,
    rightText: type ? 'Provide your business with clean, clear, expertly managed water' : '',
    rightTextStyle: {
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '28px',
      color: '#ffffff'
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "welcome-user-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-scr otp-screen-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "full-height"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-image-container welcome-scr-banner"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    url: props.welcomeScreenImage
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "banner-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      color: '#FFFFFF',
      lineHeight: '1.2',
      marginBottom: '16px',
      fontWeight: 600
    },
    variant: "header-text",
    headerText: props.bannerHeaderText
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      color: '#FFFFFF',
      lineHeight: '1.4',
      fontSize: 20,
      marginBottom: '16px',
      fontWeight: 400
    },
    variant: "header-text",
    headerText: props.bannerDetailText
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen-title"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.forgotPasswordHeaderText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen-detail"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "simple-text",
    headerStyle: {
      color: '#333333',
      fontSize: '16px'
    },
    headerText: props.forgotPasswordDetailText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "otp-input-container"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 20,
      color: '#333333',
      alignSelf: 'center'
    },
    variant: "header-text",
    headerText: "6-digit code"
  }), /*#__PURE__*/_react.default.createElement(_CustomOtpInput.CustomOtpInput, {
    otpVal: props.otpValue,
    onChangeOtp: props.onChnageOtp,
    otpCount: props.otpCount,
    newContainerStyle: {
      alignSelf: 'center'
    },
    seperatorStyle: {
      marginRight: 10
    },
    newInputStyle: props.invalidOtp ? {
      border: '1px solid #E00932'
    } : {
      border: '1px solid #BFC1C4'
    }
  }), props.invalidOtp ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 13,
      color: '#E00932',
      marginTop: '4px'
    },
    variant: "header-text",
    headerText: "Please enter a valid code."
  }) : null)), props.newPasswordPlaceholder && /*#__PURE__*/_react.default.createElement("div", {
    className: "enter-password-container ".concat(props.errorMessage && props.isNewPasswordTouch ? "P-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.passwordText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10,
      marginTop: '8px'
    },
    placeholder: props.newPasswordPlaceholder,
    inputType: "password",
    value: props.newpassword,
    onchange: props.onChangeNewPassword,
    onBlur: props.handleNewPasswordBlur
  }), props.errorMessage && props.isNewPasswordTouch && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "#E00932"
    }
  }, "Password does not meet requirements"), props.errorMessage && props.isNewPasswordTouch && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warningIcon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-validation"
  }, props.validationText1 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasMinLength
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationText1
  })), props.validationText2 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasOneUpperLowerCase
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationText2
  })), props.validationText3 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasOneNumber
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationText3
  })), props.validationText4 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasSpecialChar
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationText4
  }))), props.confirmPasswordPlaceholder && /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-confirm-input-wrapper ".concat(props.conFirmErrorMessage ? "p2-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.confirmPassword
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10,
      marginTop: '8px'
    },
    placeholder: props.confirmPasswordPlaceholder,
    inputType: "password",
    value: props.confirmNewPassword,
    onchange: props.onChangeConfirmNewPassword
  }), props.conFirmErrorMessage && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "#E00932"
    }
  }, "Passwords do not match"), props.conFirmErrorMessage && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warningIcon2"
  }), props.passwordMatched && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.successGreenTick.default,
    alt: "",
    className: "input-greenIcon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(props.isFromEmailUpdate ? "email-update" : "email-button")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      marginBottom: 10,
      display: 'block',
      fontWeight: 600,
      marginTop: 8,
      textAlign: 'left'
    },
    variant: "header-text",
    headerText: "Didn’t receive an email?"
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      marginBottom: 10,
      display: 'block',
      marginTop: 8,
      textAlign: 'left',
      fontWeight: 400
    },
    variant: "header-text",
    headerText: "Please check in your Spam or All mail."
  })), !props.resendCodePressed ? /*#__PURE__*/_react.default.createElement("div", {
    className: "email-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#E00932',
      marginBottom: 10,
      display: 'block',
      fontWeight: 400,
      marginTop: 8,
      textAlign: 'center'
    },
    variant: "header-text",
    headerText: "Please press Re-Send Code after the time elapses."
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: "center",
      alignItems: "center",
      fontSize: '27px',
      fontWeight: '600',
      color: "#0B3471"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactCountdown.default, {
    date: Date.now() + 30000,
    style: {
      color: "#0B3471"
    },
    zeroPadTime: 2,
    daysInHours: true,
    zeroPadDays: 2,
    precision: 2,
    onComplete: props.onComplete,
    renderer: renderer
  }))) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-button-container-forgot"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-button-wrapper-forgot"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.resetButtonText,
    onClick: props.onClickReset,
    disabled: !props.isDisabled
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "reset-password-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: props.resendCodeButtonText,
    onClick: props.onClickResendCode,
    disabled: !props.resendDisabled
  }))))))))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
};
var _default = exports.default = ForgotPasswordOtpComponent;